import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightGreen18Px = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.77869 4.5L6.72119 5.5575L10.1562 9L6.72119 12.4425L7.77869 13.5L12.2787 9L7.77869 4.5Z",
		fill: "#14803C"
	})
});
export default SvgChevronRightGreen18Px;
